var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.99992V10.9999M9.25 4.49991H5.8C4.11984 4.49991 3.27976 4.49991 2.63803 4.82689C2.07354 5.11451 1.6146 5.57345 1.32698 6.13794C0.999998 6.77968 0.999999 7.61976 1 9.29991L1 10.4999C1 11.4318 1 11.8977 1.15224 12.2653C1.35523 12.7553 1.74458 13.1447 2.23463 13.3477C2.60218 13.4999 3.06812 13.4999 4 13.4999V17.7499C4 17.9821 4 18.0982 4.00963 18.1959C4.10316 19.1455 4.85441 19.8968 5.80397 19.9903C5.90175 19.9999 6.01783 19.9999 6.25 19.9999C6.48217 19.9999 6.59826 19.9999 6.69604 19.9903C7.64559 19.8968 8.39685 19.1455 8.49037 18.1959C8.5 18.0982 8.5 17.9821 8.5 17.7499V13.4999H9.25C11.0164 13.4999 13.1772 14.4468 14.8443 15.3556C15.8168 15.8857 16.3031 16.1508 16.6216 16.1118C16.9169 16.0756 17.1402 15.943 17.3133 15.701C17.5 15.4401 17.5 14.9179 17.5 13.8736V4.1262C17.5 3.08191 17.5 2.55976 17.3133 2.2988C17.1402 2.05681 16.9169 1.92421 16.6216 1.88804C16.3031 1.84903 15.8168 2.11411 14.8443 2.64427C13.1772 3.55302 11.0164 4.49991 9.25 4.49991Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdds);
export default __webpack_public_path__ + "static/media/Adds.01e409af5e677feab34d9c2a82e918bc.svg";
export { ForwardRef as ReactComponent };